import React from 'react';
import { motion } from 'framer-motion';
import { Star, User } from 'lucide-react';
const testimonials = [{
  name: 'María López',
  details: '34 años, Buenos Aires, Argentina',
  text: 'Antes perdía horas armando planificaciones. Con el MegaPack, llego al aula con todo resuelto. Me cambió la vida profesional.',
  color: 'bg-pink-500'
}, {
  name: 'Carlos Mendoza',
  details: '41 años, Bogotá, Colombia',
  text: 'Las rúbricas de evaluación son increíbles. Por fin puedo evaluar con criterios claros y sin estrés.',
  color: 'bg-blue-500'
}, {
  name: 'Luciana Ferreira',
  details: '29 años, Montevideo, Uruguay',
  text: 'Soy profe nueva y este material me dio la seguridad que necesitaba. Las actividades son variadas y los chicos las disfrutan.',
  color: 'bg-purple-500'
}, {
  name: 'Roberto Guzmán',
  details: '38 años, Ciudad de México, México',
  text: 'Trabajo en una escuela con espacio limitado. El bono de espacios reducidos fue un salvavidas.',
  color: 'bg-green-500'
}, {
  name: 'Andrea Villalba',
  details: '32 años, Lima, Perú',
  text: 'Me siento organizada y profesional. Mis colegas me preguntan cómo hago para tener todo tan ordenado.',
  color: 'bg-orange-500'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-gray-50 overflow-hidden" data-id="element-208">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-209">
        <div className="text-center mb-16" data-id="element-210">
          <h2 className="text-3xl md:text-4xl font-black text-[#0F172A] mb-4" data-id="element-211">
            Lo que dicen otros profes
          </h2>
          <div className="flex justify-center gap-1 text-[#F59E0B] mb-4" data-id="element-212">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-213" />)}
          </div>
          <p className="text-gray-600" data-id="element-214">
            Docentes de toda Latinoamérica ya están usando el MegaPack
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-215">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 flex flex-col" data-id="element-216">
              <div className="flex items-center gap-4 mb-6" data-id="element-217">
                <div className={`w-12 h-12 rounded-full ${t.color} flex items-center justify-center text-white font-bold text-xl shadow-md`} data-id="element-218">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-219">
                  <h4 className="font-bold text-[#0F172A]" data-id="element-220">{t.name}</h4>
                  <p className="text-xs text-gray-500" data-id="element-221">{t.details}</p>
                </div>
              </div>

              <div className="flex-1" data-id="element-222">
                <div className="flex gap-0.5 text-[#F59E0B] mb-3" data-id="element-223">
                  {[...Array(5)].map((_, starI) => <Star key={starI} className="w-4 h-4 fill-current" data-id="element-224" />)}
                </div>
                <p className="text-gray-700 italic leading-relaxed" data-id="element-225">
                  "{t.text}"
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}